import React from "react";

// Images
import successStory1 from "../../assets/images/img-success-story-the-economist.jpg";
import SuccessStory from "./partials/SuccessStory";

const SuccessStories = ({id, storiesDataStatic, title}) => {

	return (
		<section className="section-success-stories" id={id}>
			<div className="container">
				<h2>{title}</h2>
				<div className="row">
					{storiesDataStatic.map((story, key) => {
						return <SuccessStory image={story.image} client={story.client} challenge={story.challenge} solution={story.solution} quote={story.quote} key={key} url={story.url} />;
					})}
				</div>
			</div>
		</section>
	);
};

export default SuccessStories;
